/**
 * Centralized authentication utilities
 */

/**
 * Clear authentication data and redirect to login
 * This function should be used consistently across the app for logout/auth failures
 */
export function clearAuthAndRedirect(): void {
    // Clear stored authentication data
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    localStorage.removeItem('apiKey');

    // Redirect to login if not already there
    if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
    }
}

/**
 * Clear authentication data without redirect
 * Useful for logout scenarios where redirect is handled elsewhere
 */
export function clearAuthData(): void {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    localStorage.removeItem('apiKey');
}